module.exports = __webpack_public_path__ + "static/media/AVG_Callout.d9e049d8.svg";